import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "localization-and-platforms"
    }}>{`Localization and Platforms`}</h1>
    <h2 {...{
      "id": "localization"
    }}>{`Localization`}</h2>
    <p>{`Sometimes it's necesssary (for localization or other reasons) to find out what a plugin's host environment is. Here's how to do that:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const host = require('uxp').host;
const locale = host.uiLocale;
const hostName = host.name
const hostVersion = host.version;

console.log(\`locale: \${locale}  host \${hostName} version \${hostVersion}\`);
`}</code></pre>
    <p>{`You can use the returned strings in `}<inlineCode parentName="p">{`switch`}</inlineCode>{` statements (or other control flow techniques) to alter your plugin's behavior, such as outputting the correct strings in messages and dialogs.`}</p>
    <p>{`You can also use it to change properties of HTML components in your panels (typically the `}<inlineCode parentName="p">{`innerHTML`}</inlineCode>{` or `}<inlineCode parentName="p">{`innerText`}</inlineCode>{` property) so they contain the correct language strings.`}</p>
    <h2 {...{
      "id": "os-identification"
    }}>{`OS Identification`}</h2>
    <p>{`Sometimes you need to write different code depending upon whether your plugin is hosted on macOS or Windows. You can find out what app your plugin is hosted in with this methods:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const hostOS = require('os').platform(); 
// note that this is a method, not a property.
`}</code></pre>
    <p><inlineCode parentName="p">{`hostOS`}</inlineCode>{` will contain the string "darwin" for macOS and "windows" for, well, Windows.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      